import React from 'react';

const PrivacyPolicy = () => (
  <div className="max-w-3xl mx-auto p-8">
    <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
    <p className="mb-4">
      We respect your privacy. Your data is stored securely and never sold to third parties. We only use your information to provide and improve our services.
    </p>
    <p>
      For more details, contact us at <a href="mailto:support@tailrd.com" className="text-blue-600 underline">support@tailrd.com</a>.
    </p>
  </div>
);

export default PrivacyPolicy;
